import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaptainDeletionRequestComponent } from './captain-deletion-request.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [CaptainDeletionRequestComponent],
  exports: [CaptainDeletionRequestComponent],
  imports: [CommonModule, MatButtonModule],
})
export class CaptainDeletionRequestModule {}
